import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openModalBottom } from '../../../../actions/ui';
import { ChevronDownIcon } from '../../../../assets/svg/iconos';

const useOutsideClick = ( ref, callback, when ) => {
    const savedCallback = useRef( callback );

    useEffect(() => {
        savedCallback.current = callback;
    });

    const handler = (e) => {
        if( ref.current && !ref.current.contains(e.target)) {
            savedCallback.current();
        }
    };

    useEffect(() => {
        if (when) {
            document.addEventListener('click', handler);
            return () => document.removeEventListener('click', handler);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [when]);
}

export const PlanSelect = ({ objEmpresa, dataChange, editMode }) => {

    const dispatch = useDispatch();
    const { planes } = useSelector(state => state.planes);

    const defaultPlan = planes && planes.length > 0 ? planes[0] : null;

    React.useEffect(() => {
        if (!objEmpresa.plan && defaultPlan) {
            dataChange('plan', defaultPlan);
        }
    }, [objEmpresa.plan, defaultPlan, dataChange]);
    
  return (
    <div className="business-plan">
        <div className="plan-display">
            <p>Plan Pro</p>
        </div>
    </div>
  )
}
